export const SET_MODAL_OPEN = "SET_MODAL_OPEN";
export const SET_MODAL_TEMPLATE = "SET_MODAL_TEMPLATE";
export const SET_MODAL_DATA = "SET_MODAL_DATA";
export const SET_MODAL_STATE = "SET_MODAL_STATE";
export const SET_MODAL_CLOSED = "SET_MODAL_CLOSED";

export function setModalOpen(open: boolean) {
	return {
		type: SET_MODAL_OPEN,
		payload: open
	}
}

export function setModalTemplate(template: string) {
	return {
		type: SET_MODAL_TEMPLATE,
		payload: template
	}
}

export function setModalData(data: any) {
	return {
		type: SET_MODAL_DATA,
		payload: data
	}
}

export function setModalState(state: any) {
	return {
		type: SET_MODAL_STATE,
		payload: state
	}
}

export function setModalClosed() {
	return { type: SET_MODAL_CLOSED }
}